export default __webpack_public_path__ + "static/mamf-white-logo-9532cba712b7e4c654a8f2231ed7073c.svg";